import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { FormV2FormSignatureLog } from './form-v2-form-signature-log'

export class FormV2FormSignatureLogsRepository extends BaseRepository<FormV2FormSignatureLog> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/forms-v2/form-signature-logs', token, cache)
    }
}
